export default __webpack_public_path__ + "static/media/mobile.ba07fa8e.jpg";